import { render, staticRenderFns } from "./templateModel.vue?vue&type=template&id=34ff5eee"
import script from "./templateModel.vue?vue&type=script&lang=js"
export * from "./templateModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34ff5eee')) {
      api.createRecord('34ff5eee', component.options)
    } else {
      api.reload('34ff5eee', component.options)
    }
    module.hot.accept("./templateModel.vue?vue&type=template&id=34ff5eee", function () {
      api.rerender('34ff5eee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/templateManage/templateModel.vue"
export default component.exports